import { createContext, useContext } from "react";

import { ISubmissionFormMetaContext } from "@ui-components/form/submission-form/context/SubmissionFormMetaContext.types.ts";

export const SubmissionFormMetaContext =
  createContext<ISubmissionFormMetaContext>({} as ISubmissionFormMetaContext);

export const useSubmissionFormMetaContext = () =>
  useContext(SubmissionFormMetaContext);
